<template>
  <b-row class="">
    <b-col cols="12 mb-1">
      <b-row>
        <b-col
          cols="auto"
          style="margin-top:2rem"
        >
          <b-form-checkbox
            :checked="isGrupoSelecionado()"
            switch
            @change="checkAllGrupo()"
          >
            <h6
              style="margin-top: 0.15rem"
              class="text-uppercase"
            >
              {{ grupo.descricao }}
            </h6>
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-for="recurso in recursos"
          :key="recurso.nome"
          cols="3"
        >
          <b-form-checkbox
            :checked="selecionado(recurso.nome)"
            :disabled="deveDesabilitar(recurso.nome)"
            style="margin-top: 0.75rem"
            switch
            @change="selecionar(recurso.nome)"
          >
            <div class="d-flex align-items-center">
              {{ recurso.descricao }}
              <feather-icon
                v-if="recurso.nome === 'visualizar_senha_certificado'"
                v-b-tooltip.hover
                title="Campo visível somente para administrador"
                icon="InfoIcon"
                class="text-primary ml-1"
              />
            </div>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  nome: 'GrupoPermissao',
  props: {
    recursos: {
      type: Array,
      required: true,
    },
    grupo: {
      type: Object,
      required: true,
    },
    selecionados: {
      type: Array,
      default: () => [],
    },
    isAdm: {
      type: Boolean,
    },
  },
  data() {
    return {
      selecionadosIn: [],
    }
  },
  created() {
    this.selecionadosIn = this.selecionados
  },
  methods: {
    deveDesabilitar(recursoNome) {
      if (recursoNome.endsWith('_atualizacao')) {
        const principal = recursoNome.replace('_atualizacao', '')
        return !this.selecionados.includes(principal)
      }
      if (recursoNome === 'visualizar_senha_certificado') {
        return !this.selecionados.includes('certificadodigital')
      }
      return false
    },
    isGrupoSelecionado() {
      return this.recursos.every(every => this.selecionados.includes(every.nome) || this.deveDesabilitar(every.nome))
    },
    checkAllGrupo() {
      const allSelected = this.isGrupoSelecionado()

      this.selecionados = this.selecionados.filter(selecionado => !this.recursos.some(recurso => recurso.nome === selecionado))

      if (!allSelected) {
        this.recursos.forEach(recurso => {
          if (!this.deveDesabilitar(recurso.nome)) {
            this.selecionados.push(recurso.nome)
          }
        })
      } else {
        this.recursos.forEach(recurso => {
          const recursoNome = recurso.nome

          if (!recursoNome.endsWith('_atualizacao')) {
            const atualizacao = `${recursoNome}_atualizacao`
            const index = this.selecionados.indexOf(atualizacao)
            if (index >= 0) {
              this.selecionados.splice(index, 1)
            }
          }

          if (recursoNome === 'certificadodigital') {
            const indexSenha = this.selecionados.indexOf('visualizar_senha_certificado')
            if (indexSenha >= 0) {
              this.selecionados.splice(indexSenha, 1)
            }
          }
        })
      }

      this.$emit('checkAll', this.selecionados)
    },
    selecionar(recurso) {
      const index = this.selecionados.indexOf(recurso)

      if (index >= 0) {
        this.selecionados.splice(index, 1)
        const atualizacao = `${recurso}_atualizacao`
        const indexAtualizacao = this.selecionados.indexOf(atualizacao)

        if (indexAtualizacao >= 0) {
          this.selecionados.splice(indexAtualizacao, 1)
        }

        if (recurso === 'certificadodigital') {
          const indexSenha = this.selecionados.indexOf('visualizar_senha_certificado')
          if (indexSenha >= 0) {
            this.selecionados.splice(indexSenha, 1)
          }
        }

        // Se a DCTFWeb for desabilitado, o MIT também deve ser desabilitado
        if (recurso === 'declaracao_dctfweb') {
          const indexMit = this.selecionados.indexOf('mit_apuracao')
          if (indexMit >= 0) {
            this.selecionados.splice(indexMit, 1)
            const atualizacaoMit = 'mit_apuracao_atualizacao'
            const indexAtualizacaoMit = this.selecionados.indexOf(atualizacaoMit)
            if (indexAtualizacaoMit >= 0) {
              this.selecionados.splice(indexAtualizacaoMit, 1)
            }
          }
        }
      } else {
        this.selecionados.push(recurso)

        // Se o MIT for habilitado, DCTFWeb também deve ser habilitado
        if (recurso === 'mit_apuracao') {
          if (!this.selecionados.includes('declaracao_dctfweb')) {
            this.selecionados.push('declaracao_dctfweb')
          }
        }
      }

      this.$emit('check', this.selecionados)
    },
    selecionado(recurso) {
      return this.selecionados.includes(recurso)
    },
  },
}
</script>
